(ns ui.components.input.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Input/styles.json
;; Source commit: bc1f84d34ddfcddabbd69f7f665931d25312082d
;; ----------------------------------------------------------------------------

(def input
  {:affix-dropdown
   {:container "tw2-relative tw2-flex tw2-items-stretch",
    :trigger
    {:open "tw2-bg-dropdown-bg-pressed",
     :suffix
     "tw2-border-l tw2-border-dropdown-border-default tw2-rounded-r-field tw2-rounded-l-none",
     :error-suffix "tw2-border-l-field-border-error",
     :disabled
     "tw2-cursor-not-allowed tw2-opacity-50 tw2-bg-dropdown-bg-disabled tw2-border-dropdown-border-disabled",
     :prefix
     "tw2-border-r tw2-border-dropdown-border-default tw2-rounded-l-field tw2-rounded-r-none",
     :error
     "tw2-border-field-border-error hover:tw2-border-field-border-error-hover group-hover:tw2-border-field-border-error-hover focus:tw2-border-field-border-error-pressed active:tw2-border-field-border-error-pressed",
     :error-prefix "tw2-border-r-field-border-error",
     :base
     "tw2-flex tw2-items-center tw2-justify-between tw2-gap-1 tw2-min-w-[80px] tw2-px-dropdown-px tw2-py-field-py tw2-text-body-md tw2-bg-dropdown-bg-default tw2-border tw2-border-dropdown-border-default tw2-text-disabled hover:tw2-bg-dropdown-bg-hover hover:tw2-border-dropdown-border-hover group-hover:tw2-border-field-border-hover focus:tw2-border-dropdown-border-pressed active:tw2-border-dropdown-border-pressed tw2-transition-colors tw2-duration-150",
     :enabled "tw2-cursor-pointer"},
    :label
    "tw2-truncate tw2-text-body-md tw2-flex-1 tw2-text-left tw2-text-disabled",
    :chevron "tw2-w-3 tw2-h-3 tw2-text-disabled tw2-flex-shrink-0",
    :chevron-open "tw2-rotate-180",
    :list
    {:base
     "tw2-absolute tw2-z-modal-overlay tw2-mt-1 tw2-rounded-dropdown tw2-shadow-xs tw2-min-w-full tw2-bg-dropdown-list-bg tw2-border tw2-border-dropdown-border-default tw2-px-dropdown-list-px tw2-py-dropdown-list-py tw2-max-h-[200px] tw2-overflow-y-auto tw2-flex tw2-flex-col tw2-gap-dropdown-list-gap tw2-transition-all tw2-duration-200 tw2-ease-out tw2-origin-top",
     :visible "tw2-opacity-100 tw2-translate-y-0 tw2-scale-y-100",
     :hidden
     "tw2-opacity-0 tw2--translate-y-4 tw2-scale-y-95 tw2-pointer-events-none",
     :align-prefix "tw2-left-0",
     :align-suffix "tw2-right-0",
     :empty "tw2-text-tertiary tw2-text-body-md"},
    :item
    {:base
     "tw2-w-full tw2-px-dropdown-px tw2-py-dropdown-py tw2-text-body-md tw2-font-sans tw2-text-left hover:tw2-rounded-dropdown tw2-text-secondary tw2-flex tw2-items-center tw2-justify-between",
     :selected "tw2-bg-dropdown-bg-focus tw2-rounded-dropdown",
     :disabled "tw2-opacity-50 tw2-cursor-not-allowed",
     :hover "hover:tw2-bg-dropdown-bg-item-hover",
     :label "tw2-truncate tw2-text-left",
     :check-icon "tw2-w-4 tw2-h-4 tw2-ml-2 tw2-text-secondary"}},
   :control-group
   {:base "tw2-relative tw2-flex tw2-items-stretch tw2-group",
    :focus-ring-default
    "group-focus-within:tw2-ring-2 group-focus-within:tw2-ring-field-ring-focus group-focus-within:tw2-ring-offset-0 group-focus-within:tw2-rounded-field",
    :focus-ring-error
    "group-focus-within:tw2-ring-2 group-focus-within:tw2-ring-field-ring-error group-focus-within:tw2-ring-offset-0 group-focus-within:tw2-rounded-field"},
   :input-container {:base "tw2-relative tw2-flex-1"},
   :field {:root "tw2-flex tw2-flex-col tw2-gap-field-gap"},
   :state
   {:default
    "tw2-bg-field-bg-default tw2-border-field-border-default tw2-text-primary tw2-shadow-xs hover:tw2-bg-field-bg-hover hover:tw2-border-field-border-hover hover:tw2-shadow-sm active:tw2-bg-field-bg-pressed active:tw2-border-field-border-pressed active:tw2-shadow-xs focus-visible:tw2-bg-field-bg-focus focus-visible:tw2-border-field-border-pressed focus-visible:tw2-ring-2 focus-visible:tw2-ring-field-ring-focus focus-visible:tw2-ring-offset-0 focus-visible:tw2-outline-none focus-visible:tw2-outline-offset-0",
    :error
    "tw2-bg-field-bg-error tw2-border-field-border-error tw2-text-primary tw2-shadow-xs hover:tw2-bg-field-bg-error-hover hover:tw2-border-field-border-error-hover hover:tw2-shadow-sm active:tw2-bg-field-bg-error-pressed active:tw2-border-field-border-error-pressed active:tw2-shadow-xs focus-visible:tw2-bg-field-bg-error-focus focus-visible:tw2-border-field-border-error-pressed focus-visible:tw2-ring-2 focus-visible:tw2-ring-field-ring-error focus-visible:tw2-ring-offset-0 focus-visible:tw2-outline-none focus-visible:tw2-outline-offset-0",
    :disabled
    "tw2-bg-field-bg-disabled tw2-border-field-border-disabled tw2-text-field-text-disabled tw2-cursor-not-allowed tw2-opacity-50 tw2-shadow-none"},
   :icon
   {:start
    "tw2-absolute tw2-left-3 tw2-top-1/2 tw2-transform tw2--translate-y-1/2 tw2-w-4 tw2-h-4 tw2-flex tw2-items-center tw2-justify-center tw2-z-10",
    :end
    "tw2-absolute tw2-right-3 tw2-top-1/2 tw2-transform tw2--translate-y-1/2 tw2-w-4 tw2-h-4 tw2-flex tw2-items-center tw2-justify-center tw2-z-10"},
   :suffix-text
   {:base
    "tw2-flex tw2-items-center tw2-px-dropdown-px tw2-py-field-py tw2-text-body-md tw2-border-t tw2-border-b tw2-border-r tw2-rounded-r-field tw2-rounded-l-none tw2-text-field-placeholder-text tw2-transition-colors tw2-duration-150 tw2-cursor-text",
    :default
    "tw2-bg-field-bg-default tw2-shadow-xs tw2-border-field-border-default group-hover:tw2-bg-field-bg-hover group-hover:tw2-border-field-border-hover group-hover:tw2-shadow-sm group-focus-within:!tw2-bg-field-bg-focus group-focus-within:!tw2-border-field-border-pressed",
    :error
    "tw2-border-field-border-error group-hover:tw2-bg-field-bg-error-hover group-hover:tw2-border-field-border-error-hover group-focus-within:!tw2-bg-field-bg-error-focus group-focus-within:!tw2-border-field-border-error-pressed",
    :disabled
    "tw2-bg-field-bg-disabled tw2-border-field-border-disabled tw2-opacity-50 tw2-cursor-not-allowed tw2-shadow-none",
    :pressed
    "!tw2-bg-field-bg-pressed !tw2-border-field-border-pressed !tw2-shadow-xs",
    :pressed-error
    "!tw2-bg-field-bg-error-pressed !tw2-border-field-border-error-pressed"},
   :modifiers
   {:with-start-icon "tw2-pl-10",
    :with-prefix-and-suffix-text
    "tw2-rounded-none tw2-border-l-0 tw2-border-r-0",
    :with-prefix-dropdown "tw2-rounded-l-none tw2-border-l-0",
    :with-prefix-and-suffix-dropdown
    "tw2-rounded-none tw2-border-l-0 tw2-border-r-0",
    :with-suffix-dropdown "tw2-rounded-r-none tw2-border-r-0",
    :with-suffix-text "tw2-rounded-r-none tw2-border-r-0",
    :text-affix-active-error
    "active:!tw2-bg-transparent active:!tw2-border-transparent",
    :text-affix-pressed
    "!tw2-bg-field-bg-pressed !tw2-border-field-border-pressed !tw2-shadow-xs",
    :text-affix-active
    "active:!tw2-bg-transparent active:!tw2-border-transparent",
    :with-end-icon "tw2-pr-10",
    :text-affix-pressed-error
    "!tw2-bg-field-bg-error-pressed !tw2-border-field-border-error-pressed",
    :with-prefix-text "tw2-rounded-l-none tw2-border-l-0",
    :text-affix-group-hover
    "group-hover:tw2-bg-field-bg-hover group-hover:tw2-border-field-border-hover",
    :text-affix-group-hover-error
    "group-hover:tw2-bg-field-bg-error-hover group-hover:tw2-border-field-border-error-hover"},
   :affix-wrapper {:base "tw2-flex tw2-items-stretch"},
   :label
   {:base "tw2-text-label-md tw2-cursor-pointer tw2-text-primary",
    :disabled "tw2-text-disabled tw2-cursor-not-allowed",
    :required "tw2-text-error tw2-ml-1"},
   :prefix-text
   {:base
    "tw2-flex tw2-items-center tw2-px-dropdown-px tw2-py-field-py tw2-text-body-md tw2-border-t tw2-border-b tw2-border-l tw2-rounded-l-field tw2-rounded-r-none tw2-text-field-placeholder-text tw2-transition-colors tw2-duration-150 tw2-cursor-text",
    :default
    "tw2-bg-field-bg-default tw2-shadow-xs tw2-border-field-border-default group-hover:tw2-bg-field-bg-hover group-hover:tw2-border-field-border-hover group-hover:tw2-shadow-sm group-focus-within:!tw2-bg-field-bg-focus group-focus-within:!tw2-border-field-border-pressed",
    :error
    "tw2-border-field-border-error group-hover:tw2-bg-field-bg-error-hover group-hover:tw2-border-field-border-error-hover group-focus-within:!tw2-bg-field-bg-error-focus group-focus-within:!tw2-border-field-border-error-pressed",
    :disabled
    "tw2-bg-field-bg-disabled tw2-border-field-border-disabled tw2-opacity-50 tw2-cursor-not-allowed tw2-shadow-none",
    :pressed
    "!tw2-bg-field-bg-pressed !tw2-border-field-border-pressed !tw2-shadow-xs",
    :pressed-error
    "!tw2-bg-field-bg-error-pressed !tw2-border-field-border-error-pressed"},
   :base
   "tw2-w-full tw2-px-field-px tw2-py-field-py tw2-text-body-md tw2-bg-field-bg-default tw2-border tw2-border-field-border-default tw2-rounded-field tw2-transition-all tw2-duration-150 tw2-ease-out focus-visible:tw2-outline-none focus-visible:tw2-ring-2 focus-visible:tw2-ring-offset-2 disabled:tw2-pointer-events-none disabled:tw2-cursor-not-allowed placeholder:tw2-text-field-placeholder-text",
   :helper-text
   {:base "tw2-text-helper",
    :disabled "tw2-text-disabled",
    :error "tw2-text-error",
    :default "tw2-text-tertiary"}})
